import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';

export const StyledMenuItem = styled(Flex)`
  padding: 1rem;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
  ${({ selected }) =>
    selected && `font-weight: bold; background: ${getColor('catskillGray')};`}
  ${({ disabled }) =>
    disabled
      ? `pointer-event: none; color: ${getColor('alto')};`
      : `cursor: pointer; 
        color: ${getColor('shuttleGray')};
        :hover {
         background: ${getColor('catskillGray')};
        }
      `}
`;
